import { colors } from './constants';

export const Logo = ({ width = 24, height = 24, styles = {}, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={styles}
    {...rest}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M24.3427 -0.342696H-0.342696V24.3427H24.3427V-0.342696Z"
        fill={colors.blue}
      />
      <path
        d="M11.9976 9.6181C11.5474 9.61774 11.107 9.7486 10.73 9.99466L11.998 12.1915L13.2664 9.99466C12.8889 9.74882 12.4481 9.61799 11.9976 9.6181Z"
        fill={colors.teal}
      />
      <path
        d="M9.87773 10.1559C9.53125 9.868 9.10877 9.68675 8.66141 9.63401C8.21406 9.58128 7.76101 9.65932 7.35709 9.85871L10.8816 11.8935L9.87773 10.1559Z"
        fill={colors.teal}
      />
      <path
        d="M18.2907 5.70889C16.8352 4.25368 14.9202 3.34815 12.8719 3.14661C10.8237 2.94506 8.76887 3.45998 7.05769 4.60361C5.34651 5.74724 4.08482 7.44882 3.48759 9.41843C2.89036 11.388 2.99455 13.5038 3.78241 15.4052C4.57027 17.3066 5.99305 18.876 7.80832 19.8459C9.62359 20.8159 11.719 21.1264 13.7376 20.7246C15.7561 20.3228 17.5729 19.2335 18.8784 17.6423C20.1838 16.0511 20.8971 14.0565 20.8968 11.9984C20.8983 10.83 20.6688 9.67285 20.2216 8.59348C19.7743 7.5141 19.1181 6.53378 18.2907 5.70889ZM17.8137 9.92485C17.8137 9.93412 17.8113 9.94299 17.8097 9.95186C17.8085 9.96124 17.8068 9.97053 17.8045 9.97968C17.8045 9.98694 17.8008 9.99419 17.7988 10.0015C17.7968 10.0087 17.7928 10.0192 17.7895 10.0281C17.7863 10.0369 17.7831 10.0458 17.7791 10.0543C17.775 10.0627 17.7722 10.0684 17.7686 10.0752C17.7649 10.0821 17.7597 10.091 17.7549 10.099C17.75 10.1071 17.7452 10.1147 17.74 10.122C17.7347 10.1293 17.7291 10.1361 17.7234 10.143C17.7178 10.1498 17.7186 10.1506 17.7158 10.1539C17.7127 10.1571 17.7095 10.1602 17.7061 10.1631C17.7 10.1696 17.6944 10.1756 17.6879 10.1817C17.6815 10.1877 17.6738 10.1942 17.6666 10.1998C17.6593 10.2055 17.6529 10.2115 17.6456 10.2167C17.6383 10.222 17.6308 10.2268 17.623 10.2313C17.6194 10.2337 17.6162 10.2369 17.6121 10.2393L12.8144 13.0087L14.488 13.9763C14.7053 14.1025 14.8859 14.2831 15.0121 14.5004V14.5025C15.1396 14.7216 15.2066 14.9706 15.2064 15.2241V17.269C15.206 17.5216 15.1393 17.7698 15.013 17.9886C14.8867 18.2074 14.7053 18.3892 14.4868 18.516L12.716 19.5373C12.4972 19.6645 12.2485 19.7316 11.9954 19.7316C11.7422 19.7316 11.4935 19.6645 11.2747 19.5373L9.50316 18.516C9.28467 18.3893 9.1033 18.2074 8.97721 17.9886C8.85112 17.7697 8.78474 17.5216 8.78471 17.269V15.2233C8.78466 14.9705 8.85083 14.7221 8.97661 14.5029V14.5008C9.10318 14.2838 9.28374 14.1033 9.50074 13.9767L11.1751 13.0091L6.37737 10.2393C6.37334 10.2369 6.37011 10.2337 6.36648 10.2313C6.36285 10.2288 6.35116 10.222 6.3439 10.2167C6.33665 10.2115 6.32979 10.2059 6.32294 10.1998C6.31609 10.1938 6.30843 10.1881 6.30157 10.1817C6.29472 10.1752 6.28948 10.1692 6.28343 10.1627C6.27738 10.1563 6.27658 10.1571 6.27335 10.1534C6.27012 10.1498 6.26891 10.1462 6.26609 10.143C6.26327 10.1397 6.2548 10.1293 6.24956 10.122C6.24432 10.1147 6.23948 10.1067 6.23465 10.099C6.22981 10.0914 6.22497 10.0829 6.22053 10.0748L6.21045 10.0543C6.20683 10.0458 6.2036 10.0369 6.19997 10.0281C6.19634 10.0192 6.19352 10.0103 6.1907 10.001C6.18788 9.99178 6.18667 9.98653 6.18506 9.97928C6.18344 9.97202 6.18143 9.96113 6.17981 9.95186C6.1782 9.94259 6.17659 9.93372 6.17578 9.92445C6.17498 9.91517 6.17578 9.90711 6.17578 9.89864C6.17578 9.89018 6.17578 9.88977 6.17578 9.88534C6.17578 9.12118 6.32629 8.36451 6.61873 7.65852C6.91116 6.95253 7.33978 6.31105 7.88012 5.77071C8.42046 5.23037 9.06194 4.80175 9.76793 4.50932C10.4739 4.21688 11.2306 4.06637 11.9948 4.06637C12.7589 4.06637 13.5156 4.21688 14.2216 4.50932C14.9276 4.80175 15.5691 5.23037 16.1094 5.77071C16.6497 6.31105 17.0784 6.95253 17.3708 7.65852C17.6632 8.36451 17.8137 9.12118 17.8137 9.88534C17.8137 9.88977 17.8137 9.89421 17.8137 9.89864C17.8137 9.90308 17.8145 9.918 17.8137 9.92485Z"
        fill={colors.teal}
      />
      <path
        d="M15.6027 9.6181C15.0596 9.61792 14.5336 9.80808 14.1162 10.1555L13.1143 11.8936L16.6368 9.8596C16.3153 9.70056 15.9614 9.61791 15.6027 9.6181Z"
        fill={colors.teal}
      />
      <path
        d="M18.8684 5.13076C17.279 3.54101 15.1875 2.55157 12.9503 2.33105C10.7132 2.11052 8.46873 2.67256 6.59949 3.92137C4.73026 5.17019 3.35188 7.02853 2.69923 9.17972C2.04658 11.3309 2.16004 13.6419 3.02029 15.7188C3.88053 17.7957 5.43432 19.5101 7.41689 20.5698C9.39947 21.6295 11.6882 21.9689 13.893 21.5303C16.0978 21.0917 18.0823 19.9021 19.5083 18.1643C20.9344 16.4265 21.7138 14.248 21.7136 12C21.7151 10.7241 21.4645 9.46038 20.9763 8.28155C20.488 7.10272 19.7717 6.03196 18.8684 5.13076ZM11.9996 20.8948C9.941 20.8953 7.94592 20.1819 6.35433 18.8763C4.76275 17.5707 3.67313 15.7536 3.27115 13.7346C2.86917 11.7156 3.17971 9.61974 4.14984 7.80408C5.11998 5.98841 6.68968 4.56532 8.59148 3.77729C10.4933 2.98927 12.6095 2.88507 14.5795 3.48246C16.5495 4.07985 18.2514 5.34186 19.3952 7.05344C20.539 8.76503 21.0539 10.8203 20.8522 12.869C20.6505 14.9176 19.7447 16.833 18.2891 18.2887C17.4642 19.1162 16.484 19.7726 15.4047 20.2202C14.3255 20.6678 13.1684 20.8977 12 20.8968L11.9996 20.8948Z"
        fill={colors.blue}
      />
      <path
        d="M13.2857 5.05175C13.4369 5.33271 13.5624 5.62674 13.6606 5.93026C13.9497 6.79507 14.1372 7.90218 14.1916 9.13548C14.6163 8.92203 15.0839 8.80772 15.5592 8.80116C16.0345 8.79459 16.5051 8.89594 16.9356 9.09758C16.7831 8.14267 16.3572 7.25239 15.7095 6.53438C15.0618 5.81638 14.2199 5.30141 13.2857 5.05175Z"
        fill="white"
      />
      <path
        d="M14.3933 17.2682V15.333L12.4068 16.4796V18.7724L14.0812 17.8048C14.1753 17.7502 14.2536 17.672 14.3084 17.5779C14.3631 17.4838 14.3923 17.377 14.3933 17.2682Z"
        fill="white"
      />
      <path
        d="M11.9984 13.5772C11.889 13.5772 11.7816 13.6058 11.6867 13.6603L10.0116 14.6279L11.9972 15.7741L13.9828 14.6279L12.3092 13.6603C12.2147 13.6058 12.1075 13.5772 11.9984 13.5772Z"
        fill="white"
      />
      <path
        d="M11.9976 4.88361C11.9441 4.8856 11.8922 4.9028 11.848 4.9332C11.759 4.99264 11.6808 5.06697 11.617 5.15293C11.4449 5.36984 11.263 5.72906 11.1106 6.18868C10.8582 6.94463 10.6784 7.96868 10.6224 9.11611C11.0513 8.90863 11.5216 8.80085 11.998 8.80085C12.4745 8.80085 12.9447 8.90863 13.3736 9.11611C13.3492 8.59541 13.2954 8.0765 13.2124 7.56188C13.0979 6.8656 12.9334 6.26246 12.7419 5.80728C12.6153 5.50369 12.4758 5.26662 12.3459 5.11422C12.2892 5.04389 12.2219 4.98282 12.1464 4.9332C12.1022 4.9028 12.0504 4.8856 11.9968 4.88361H11.9976Z"
        fill="white"
      />
      <path
        d="M11.5887 16.4812L9.60394 15.3354V17.2682C9.6039 17.3777 9.63268 17.4853 9.68738 17.5801C9.74209 17.6749 9.82079 17.7537 9.91558 17.8085L11.5887 18.7733V16.4812Z"
        fill="white"
      />
      <path
        d="M8.39121 8.80085C8.88131 8.80064 9.36462 8.91539 9.80231 9.13588C9.82653 8.56413 9.88414 7.99429 9.97487 7.42926C10.0978 6.6842 10.2736 6.02703 10.499 5.49122C10.562 5.3409 10.6331 5.19407 10.7119 5.05136C9.77681 5.30038 8.93402 5.81517 8.28557 6.53339C7.63712 7.25161 7.21083 8.14244 7.05832 9.09799C7.47538 8.90218 7.93048 8.80072 8.39121 8.80085Z"
        fill="white"
      />
      <path
        d="M16.1123 5.77062C15.2985 4.95696 14.2616 4.40289 13.1329 4.17845C12.0041 3.95402 10.8342 4.06929 9.77096 4.5097C8.70772 4.95012 7.79894 5.69589 7.15952 6.65274C6.52009 7.60959 6.17873 8.73455 6.17859 9.88539C6.17859 9.88982 6.17859 9.89385 6.17859 9.89869C6.17859 9.90353 6.17859 9.91603 6.17859 9.92449C6.17859 9.93296 6.18101 9.94264 6.18262 9.95191C6.18423 9.96118 6.18585 9.97046 6.18786 9.97932C6.18988 9.98819 6.19149 9.99384 6.19351 10.0011C6.19552 10.0084 6.19955 10.0192 6.20278 10.0281C6.206 10.037 6.20963 10.0458 6.21326 10.0543L6.22334 10.0749C6.22778 10.0829 6.23261 10.091 6.23745 10.0991C6.24229 10.1071 6.24713 10.1144 6.25237 10.122C6.25761 10.1297 6.26326 10.1362 6.2689 10.143C6.27454 10.1499 6.27333 10.1503 6.27616 10.1535C6.27898 10.1567 6.28301 10.1595 6.28624 10.1628C6.28946 10.166 6.29793 10.1757 6.30438 10.1817C6.31083 10.1878 6.31849 10.1938 6.32575 10.1999C6.333 10.2059 6.33945 10.2116 6.34671 10.2168C6.35397 10.222 6.36163 10.2265 6.36929 10.2313C6.37695 10.2361 6.37614 10.237 6.38017 10.2394L11.1779 13.0092L9.50355 13.9768C9.28655 14.1033 9.10599 14.2839 8.97943 14.5009V14.5029C8.85364 14.7222 8.78747 14.9706 8.78752 15.2234V17.2683C8.78755 17.5208 8.85393 17.769 8.98002 17.9878C9.10611 18.2067 9.28748 18.3886 9.50597 18.5153L11.2775 19.5365C11.4963 19.6638 11.745 19.7309 11.9982 19.7309C12.2513 19.7309 12.5 19.6638 12.7188 19.5365L14.4896 18.5153C14.7081 18.3885 14.8896 18.2066 15.0158 17.9878C15.1421 17.769 15.2088 17.5209 15.2092 17.2683V15.2234C15.209 14.9706 15.1423 14.7223 15.0159 14.5034C14.8896 14.2845 14.7079 14.1026 14.4892 13.976L12.8156 13.0084L17.6134 10.239C17.6174 10.2365 17.6206 10.2333 17.6242 10.2309C17.632 10.2264 17.6395 10.2216 17.6468 10.2164C17.6541 10.2111 17.6609 10.2055 17.6678 10.1995C17.6746 10.1934 17.6823 10.1878 17.6892 10.1813C17.696 10.1749 17.7012 10.1692 17.7073 10.1628C17.7107 10.1599 17.7139 10.1568 17.717 10.1535C17.7198 10.1503 17.7218 10.1462 17.7246 10.1426C17.7275 10.139 17.7359 10.1289 17.7412 10.1216C17.7464 10.1144 17.7512 10.1063 17.7561 10.0987C17.7609 10.091 17.7658 10.0829 17.7698 10.0749C17.7738 10.0668 17.777 10.0612 17.7803 10.0539C17.7835 10.0467 17.7875 10.0366 17.7908 10.0277C17.794 10.0188 17.7972 10.01 17.8 10.0011C17.8028 9.99223 17.8041 9.98658 17.8057 9.97932C17.808 9.97017 17.8097 9.96088 17.8109 9.95151C17.8109 9.94264 17.8141 9.93377 17.8149 9.92449C17.8157 9.91522 17.8149 9.90716 17.8149 9.89829C17.8149 9.88942 17.8149 9.88942 17.8149 9.88498C17.8161 9.12085 17.6662 8.36403 17.374 7.65797C17.0819 6.95191 16.6531 6.31051 16.1123 5.77062ZM14.0808 17.8081L12.4064 18.7757V16.4813L14.3932 15.3347V17.2699C14.3928 17.3795 14.3637 17.487 14.3087 17.5818C14.2537 17.6766 14.1749 17.7553 14.08 17.8101L14.0808 17.8081ZM9.91559 17.8081C9.8208 17.7533 9.74209 17.6746 9.68739 17.5797C9.63268 17.4849 9.6039 17.3773 9.60394 17.2679V15.3355L11.5888 16.4813V18.7733L9.91559 17.8081ZM11.9976 15.7729L10.0119 14.6271L11.6871 13.6595C11.7819 13.605 11.8893 13.5764 11.9986 13.5764C12.1079 13.5764 12.2153 13.605 12.31 13.6595L13.9836 14.6271L11.9976 15.7729ZM10.73 9.99464C11.1073 9.74892 11.5479 9.61811 11.9982 9.61811C12.4485 9.61811 12.889 9.74892 13.2664 9.99464L11.998 12.1915L10.73 9.99464ZM12.1471 4.93323C12.2227 4.98285 12.29 5.04392 12.3467 5.11425C12.4765 5.26665 12.616 5.50372 12.7426 5.8073C12.9341 6.26249 13.0986 6.86563 13.2131 7.56191C13.2962 8.07653 13.35 8.59543 13.3744 9.11613C12.9455 8.90865 12.4752 8.80087 11.9988 8.80087C11.5223 8.80087 11.0521 8.90865 10.6232 9.11613C10.6792 7.96871 10.859 6.94465 11.1114 6.18871C11.2638 5.72909 11.4456 5.36986 11.6178 5.15296C11.6816 5.067 11.7598 4.99267 11.8488 4.93323C11.8929 4.90283 11.9448 4.88563 11.9984 4.88364C12.0517 4.88578 12.1032 4.90298 12.1471 4.93323ZM15.6027 8.80085C15.1127 8.80074 14.6294 8.91534 14.1916 9.13549C14.136 7.90339 13.9473 6.79508 13.6594 5.93027C13.5612 5.62674 13.4357 5.33271 13.2845 5.05176C14.2189 5.30122 15.0611 5.8161 15.7091 6.53411C16.357 7.25213 16.7831 8.14253 16.9356 9.09759C16.5185 8.90209 16.0634 8.80079 15.6027 8.80085ZM10.7106 5.05136C10.6319 5.19406 10.5608 5.3409 10.4978 5.49122C10.274 6.02703 10.0982 6.6842 9.97365 7.42926C9.88292 7.99429 9.82531 8.56414 9.80109 9.13589C9.37615 8.92219 8.90825 8.80774 8.43265 8.80118C7.95705 8.79461 7.48616 8.8961 7.05549 9.09799C7.20799 8.14244 7.63428 7.25161 8.28274 6.53339C8.93119 5.81517 9.77398 5.30038 10.709 5.05136H10.7106ZM8.3912 9.61808C8.93433 9.61811 9.46028 9.80841 9.87769 10.1559L10.8816 11.8936L7.35867 9.85958C7.67962 9.70054 8.03301 9.61789 8.3912 9.61808ZM14.1162 10.1555C14.4626 9.86795 14.8849 9.68687 15.332 9.63414C15.7791 9.58141 16.2319 9.65929 16.6357 9.85837L13.1144 11.8936L14.1162 10.1555Z"
        fill={colors.blue}
      />
      <path
        d="M12.7193 19.5373V19.5377L12.718 19.5381L12.7193 19.5373Z"
        fill={colors.blue}
      />
      <path
        d="M11.2784 19.5381L11.2775 19.5373H11.2771L11.2784 19.5381Z"
        fill={colors.blue}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="23.9996" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Menu = ({
  width = 24,
  height = 24,
  color = colors.teal,
  styles = {},
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={styles}
    {...rest}
  >
    <path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" fill={color} />
  </svg>
);

export const Orders = ({ width = 24, height = 24, styles = {}, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={styles}
    {...rest}
  >
    <path
      opacity="0.3"
      d="M5 5V19H19V5H5ZM14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z"
      fill="#00FFFF"
    />
    <path
      d="M7 15H14V17H7V15ZM7 11H17V13H7V11ZM7 7H17V9H7V7ZM19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.47 3 4.72 3 5V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM19 19H5V5H19V19Z"
      fill="#00007D"
      fillOpacity="0.7"
    />
  </svg>
);

export const NewTrip = ({ width = 24, height = 24, styles = {}, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={styles}
    {...rest}
  >
    <path
      opacity="0.3"
      d="M11.17 8L10.58 7.41L9.17 6H4V18H20V8H11.17ZM14 10H16V12H18V14H16V16H14V14H12V12H14V10Z"
      fill="#00FFFF"
    />
    <path
      d="M20 6H12L10 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V8C22 6.89 21.11 6 20 6ZM20 18H4V6H9.17L10.58 7.41L11.17 8H20V18ZM12 14H14V16H16V14H18V12H16V10H14V12H12V14Z"
      fill="#00007D"
      fillOpacity="0.7"
    />
  </svg>
);

export const Scanner = ({ width = 24, height = 24, styles = {}, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={styles}
    {...rest}
  >
    <path
      opacity="0.3"
      d="M5 14V18H19V14H5ZM8 17H6V15H8V17ZM18 17H10V15H18V17Z"
      fill="#00FFFF"
    />
    <path
      d="M19.8 10.7L4.2 5L3.5 6.9L17.6 12H5C3.9 12 3 12.9 3 14V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V12.5C21 11.7 20.5 10.9 19.8 10.7ZM19 18H5V14H19V18ZM6 15H8V17H6V15ZM10 15H18V17H10V15Z"
      fill="#00007D"
      fillOpacity="0.7"
    />
  </svg>
);

export const Truck = ({ width = 24, height = 24, styles = {}, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#00007d"
    opacity="0.7"
    css={styles}
    {...rest}
  >
    <path d="M18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5M19.5,9.5L21.46,12H17V9.5M6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5M20,8H17V4H3C1.89,4 1,4.89 1,6V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V12L20,8Z" />
  </svg>
);

export const Close = ({
  width = 24,
  height = 24,
  color,
  styles = {},
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={color}
    css={styles}
    {...rest}
  >
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
);

export const Arrow = ({
  width = 24,
  height = 24,
  color,
  styles = {},
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={color}
    css={styles}
    {...rest}
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
  </svg>
);

export const Users = ({
  width = 24,
  height = 24,
  color,
  styles = {},
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={color}
    css={styles}
    {...rest}
  >
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm.05 10H4.77c.99-.5 2.7-1 4.23-1 .11 0 .23.01.34.01.34-.73.93-1.33 1.64-1.81-.73-.13-1.42-.2-1.98-.2-2.34 0-7 1.17-7 3.5V19h7v-1.5c0-.17.02-.34.05-.5zm7.45-2.5c-1.84 0-5.5 1.01-5.5 3V19h11v-1.5c0-1.99-3.66-3-5.5-3zm1.21-1.82c.76-.43 1.29-1.24 1.29-2.18C19 9.12 17.88 8 16.5 8S14 9.12 14 10.5c0 .94.53 1.75 1.29 2.18.36.2.77.32 1.21.32s.85-.12 1.21-.32z" />
  </svg>
);

export const Circle = ({
  width = 24,
  height = 24,
  color,
  styles = {},
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={color}
    css={styles}
    {...rest}
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

export const CircleChecked = ({
  width = 24,
  height = 24,
  color,
  styles = {},
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={color}
    css={styles}
    {...rest}
  >
    <path fill="none" d="M0 0h24v24H0V0zm0 0h24v24H0V0z" />
    <path d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
  </svg>
);
